export const MATH_FORMULA = 'math_formula';
export const MATH_FORMULA_BLOCK = 'math_formula_block';
